/* eslint-disable max-classes-per-file */
import _ from "lodash";
import { IForsorjningskalla } from "~app/common/models/forsorjningskalla";

export class LeverantorsorderListRequest {
    leverantorsorder: number;
    sok: string;
    leverantor: number;
    periodFrom: Date;
    periodTom: Date;
    obalans: boolean;
    ordernummer: string;
    avtalsansvarig: number;
    handelssortimentsgrupp: number;
    mottagningsplats: number;
    constructor() {
        this.leverantorsorder = null;
        this.sok = null;
        this.leverantor = null;
        this.periodFrom = null;
        this.periodTom = null;
        this.obalans = false;
        this.ordernummer = null;
        this.avtalsansvarig = null;
        this.handelssortimentsgrupp = null;
        this.mottagningsplats = null;
    }
}

export interface ILeverantorsorderListResponse {
    leverantorsorderList: any;
}

export interface ILeverantorsorderList {
    leverantor: string;
    leverantorHk: string;
    leverantorInternr: string;
    id: number;
    periodFrom: Date;
    periodTom: Date;
    ordernr: string;
    status: string;
    avtalsansvarig: string;
    handelssortimentsgrupp: string;
}

export interface IMattslag {
    id: number;
    kod: string;
    kortnamn: string;
}

export interface IHandelssortimentsgrupp {
    id: number;
    kod: string;
    namn: string;
}

export interface ILeverantorsorderDetailGrunddata {
    mattslagList: IMattslag[];
    handelssortimentsgruppList: IHandelssortimentsgrupp[];
    leverantorsorderStatusList: string[];
}

export class Fordelningstyp {
    static get period(): string { return "PERIOD"; }
    static get manad(): string { return "MANAD"; }
    static get vecka(): string { return "VECKA"; }
}

export interface IFordelaLeveransraderResponse {
    leveransrader: ILeveransrad[];
}

export interface IFordelaLeveransraderRequest {
    orderradId: number;
    isLeverantorsorder: boolean;
    periodStart: Date;
    periodSlut: Date;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export interface IFordelaForsorjningsraderRequest {
    levorderradId: number;
    kundorderradId: number;
    forsorjningskallaId: number;
    forsorjningskallaTyp: string;
    periodStart: Date;
    periodSlut: Date;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export interface IFordelaForsorjningsraderResponse {
    forsorjningsrader: IForsorjningsradResponse[];
}

export class FordelaLeveransraderRequest implements IFordelaLeveransraderRequest {
    orderradId: number;
    isLeverantorsorder: boolean;
    periodStart: Date;
    periodSlut: Date;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export class FordelaForsorjningsraderRequest implements IFordelaForsorjningsraderRequest {
    levorderradId: number;
    kundorderradId: number;
    forsorjningskallaId: number;
    forsorjningskallaTyp: string;
    periodStart: Date;
    periodSlut: Date;
    fordelningstyp: string;
    veckomallNamn: string;
    kvantitet: number;
}

export interface IGridPeriod {
    type: string;
    from: Date;
    to: Date;
    periodMonth: Date;
}

export class GridPeriod implements IGridPeriod {
    type: string;
    from: Date;
    to: Date;
    periodMonth: Date;
}

export interface IForsorjningskallaTypeaheadRequest {
    input: string;
    periodFrom: Date;
    periodTom: Date;
    handelssortimentsgruppId: number;
    mattslag: string;
}

export class ForsorjningskallaTypeaheadRequest implements IForsorjningskallaTypeaheadRequest {
    input: string;
    periodFrom: Date;
    periodTom: Date;
    handelssortimentsgruppId: number;
    mattslag: string;
}

export class UppdatateraPeriodLeveransraderRequest implements IUppdatateraPeriodLeveransraderRequest {
    periodStart: Date;
    periodSlut: Date;
    leveransrader: ILeveransrad[];
}

export class LevorderLeveransrad implements ILeveransrad {
    avtaladDagKvantitet: number;
    endastVisning: boolean;
    transporteratKvantitet: number;
    datum: Date;
    kvantitet: number;
    forsorjningsrader: IForsorjningsrad[];
}

export interface IUppdatateraPeriodLeveransraderRequest {
    periodStart: Date;
    periodSlut: Date;
    leveransrader: ILeveransrad[];
}

export interface IUppdatateraPeriodLeveransraderResponse {
    leveransrader: ILeveransrad[];
}

export interface IDeleteLeverantorsorder {
    id: number;
    rowVersion: string;
}

export interface ILeveransradSummary {
    summaKvantitet: number;
    summaForsorjningsrader: number;
    summaTransporterat: number;
    summaAvvikelse: number;
}

export interface ILeveransradPeriodFilter {
    name: string;
    year: number;
    month: number;
    week: number;
    date: number;
}

export interface IKund {
    id: number;
    namn: string;
}

export interface IHandelssortiment {
    id: number;
    namn: string;
    aktiv: boolean;
}

export interface ILagerplats {
    id: number;
    namn: string;
    aktiv: boolean;
}

export interface IAvtalsansvarig {
    userName: string;
    id: number;
    aktiv: boolean;
}

export interface IKundorderDetailKundorderrad {
    id: number;
    kvantitet: number;
    periodtyp: string;
    periodFrom: Date;
    periodTom: Date;
    leveransrader: ILeveransrad[];
    forsorjningskallor: IForsorjningskalla[];
    handelssortiment: IHandelssortiment;
    mottagningsplats: ILagerplats;
    forsorjningskallaToAdd: IForsorjningskalla;
    kvantitetToAdd: number;
    gridPeriod: IGridPeriod;
    addForsorjningsradCollapsed: boolean;
    overenskommenKvantitetLeveransrad: number;
}

export interface IFilteredLeveransradPeriod {
    period: string;
    startDate: Date;
    endDate: Date;
    leveransrader: ILeveransrad[];
    partialPeriod: boolean;
}

export interface IForsorjningsrad {
    id?: number;
    forsorjningskallaId: number;
    typ: string;
    andel: number;
    dagkvantitet: number;
    avtaladDagKvantitet: number;
    transporteratKvantitet: number;
    rowVersion: string;
}

export class Forsorjningsrad implements IForsorjningsrad {
    id: number;
    forsorjningskallaId: number;
    typ: string;
    andel: number;
    dagkvantitet: number;
    avtaladDagKvantitet: number;
    transporteratKvantitet: number;
    rowVersion: string;
    manuellPaArbetsorder: boolean;
    endastVisning: boolean;
}

export interface ILeveransrad {
    datum: Date;
    kvantitet: number;
    transporteratKvantitet: number;
    avtaladDagKvantitet: number;
    endastVisning: boolean;
    forsorjningsrader: IForsorjningsrad[];
}
export interface IUpdatedForsorjning {
    forsorjningskalla: IForsorjningskalla;
    forsorjningsgrupp: IForsorjningsradResponse[][];
}

export interface IForsorjningsradResponse {
    datum: Date;
    kvantitet: number;
}

export interface IPeriodSelected {
    type: string; // period, month, week, date
    from: Date;
    to: Date;
    periodMonth: Date;
}

export interface IForsorjningsradHandsonTable {
    forsorjningskalla: IForsorjningskalla;
    forsorjningskallor: IForsorjningskalla[];
    forsorjningsradOmradePeriod: IForsorjningsradOmradePeriod[];
    periodLista: ILeveransradPeriod[];
    summaColumn: number;
    transporteratLeveransradColumn: number;
    overenskommetColumn: number;
    avvikelseColumn: number;
    textrad: string;
    typ: string;
    col1: string;
    col2: string;
    // Identifierare för rad, kan vara kundorderid, leveransorderid
    orderradId?: number;
    kvantitettyp: Kvantitettyp;
}

export class ForsorjningsradHandsonTable implements IForsorjningsradHandsonTable {
    forsorjningskalla: IForsorjningskalla;
    forsorjningskallor: IForsorjningskalla[];
    forsorjningsradOmradePeriod: IForsorjningsradOmradePeriod[];
    periodLista: ILeveransradPeriod[];
    summaColumn: number;
    transporteratLeveransradColumn: number;
    overenskommetColumn: number;
    avvikelseColumn: number;
    textrad: string;
    typ: string;
    col1: string;
    col2: string;
    kvantitettyp: Kvantitettyp;
}

export interface ILeveransradPeriod {
    period: string;
    startDate: Date;
    endDate: Date;
    partialPeriod: boolean;
    periodType: string;
}

export interface IForsorjningsradOmradePeriod {
    periodHeader: string;
    periodStart: Date;
    periodEnd: Date;
    kvantitet: number;
    originalplanKvantitet: number;
    periodType: string;
    omatchadTransporteratKvantitet: boolean;
}

export class ForsorjningsradOmradePeriod implements IForsorjningsradOmradePeriod {
    periodHeader: string;
    periodStart: Date;
    periodEnd: Date;
    kvantitet: number;
    originalplanKvantitet: number;
    periodType: string;
    omatchadTransporteratKvantitet: boolean;
}

export class Leveransrad implements ILeveransrad {
    avtaladDagKvantitet: number;
    datum: Date;
    kvantitet: number;
    transporteratKvantitet: number;
    endastVisning: boolean;
    forsorjningsrader: IForsorjningsrad[];
}

export class ChangedValue {
    oldValue: number;
    newValue: number;

    isUnchanged(): boolean { return this.oldValue === this.newValue; }

    isInvalid(value: any): boolean { return !_.isNumber(value) || isNaN(value); }
}

export enum KvantitetChangeType {

    Leverans = 1,

    Forsorjning,

    Overenskommet
}

export interface IKvantitetChangeRequest {
    changeItem: IKvantitetChangeItem[];
}

// Binding LeveransradkvantitetChangeItem
export interface IKvantitetChangeItem {
    typ: KvantitetChangeType;
    periodStart: Date;
    periodEnd: Date;
    orderradId?: number;
    kvantitet: number;
    forsorjningskalla: IForsorjningskalla;
}

// Binding ForsorjningsradkvantitetChangeItem
export interface IForsorjningsradkvantitetChangeItem {
    forsorjningsradId: number;
    forsorjningsradTyp: string;
    periodStart: Date;
    periodEnd: Date;
    kvantitet: number;
}

// Binding interface
export interface ILeveransradComponentBinding {
    leveransradData: ILeveransrad[];
    forsorjningsKallor: IForsorjningskalla[];
    periodSelected: IPeriodSelected;
    lagerenhet: string;
    periodStart: Date;
    periodEnd: Date;
    onKvantitetChanged: (changeItemLista: any) => Promise<any>;
    searchForForsorjningskallor: (
        search: any,
        kundorderrad: IKundorderDetailKundorderrad,
        excludeForsorjningskallor?: IForsorjningskalla[]) => any;
    editMode: boolean;
}

// Controller interface
export interface ILeveransradComponentController extends ILeveransradComponentBinding {
    periodName: string;
    periodLista: ILeveransradPeriod[];
    forsorjningsKalla: IForsorjningskalla;
    forsorjningsKallorLista: IForsorjningskalla[];
    forsorjningsradLista: IForsorjningsradHandsonTable[];
}

export class KvantitetChangeItem implements IKvantitetChangeItem {
    typ: KvantitetChangeType;
    periodStart: Date;
    periodEnd: Date;
    kvantitet: number;
    orderradId: number;
    forsorjningskalla: IForsorjningskalla;
}

export interface IChangedValue {
    rowIndex: number;
    propertyName: string;
    oldValue: any;
    newValue: any;
}

export class Radtyp {
    static get plan(): string { return "plan"; }
    static get transporterat(): string { return "transporterat"; }
    static get leveransrad(): string { return "leveransrad"; }
    static get summaBalans(): string { return "summaBalans"; }
    static get summaForsorjningsrader(): string { return "summaForsorjningsrader"; }
    static get summaTransporterat(): string { return "summaTransporterat"; }
    static get avvikelse(): string { return "avvikelse"; }
}

export class Kvantitettyp {
    static get leverans(): string { return "leverans"; }
    static get forsorjning(): string { return "forsorjning"; }
    static get summa(): string { return "summa"; }
}
